import * as React from "react";
const SvgJp = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 60 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 60, height: 40, rx: 2, fill: "white" }), /* @__PURE__ */ React.createElement("circle", { cx: 30, cy: 20, r: 12, fill: "#BC002D" }));
export default SvgJp;
